import { createCardPresets } from "./card";
import { createTabsPresets } from "./tabs";
import { createInputPresets } from "./input";
import { createTablePresets } from "./table";
import { createFormPresets } from "./form";
import { createExternalPresets } from "./external";

/**
 * 컴포넌트 프리셋 조합 지점.
 *
 * designSystem.js 의 토큰을 컴포넌트별 프리셋 파일에 주입해 ds.components.* 묶음을 만든다.
 *
 *   card.js     card, cardPadded
 *   tabs.js     tabs (root/compact/channel)
 *   input.js    input (outlined)
 *   table.js    table, tableCompact, tableMini  ← 모든 표는 이 3종만 사용 (인라인 표 스타일 금지)
 *   form.js     form (field/label/requiredMark/dialogContent)
 *   external.js external (검색/제안서/키비주얼 등 자료형 화면)
 *
 * 규칙:
 * - 새 컴포넌트 프리셋은 이 디렉토리에 파일로 추가하고 여기서 조합만 한다.
 * - 색상·간격 값은 프리셋 파일에서도 tokens 로만 받는다 (하드코딩 금지).
 * - 화면 파일에서는 ds.* / ds.components.* 경로만 사용한다.
 *
 * MUI sx 숫자 단위:
 * - p, px, py, m, mt 같은 spacing 숫자는 8px 배수다.
 * - borderRadius 숫자는 theme.shape.borderRadius(8px) 배수다.
 */
export const createComponentStyles = (tokens) => ({
    ...createCardPresets(tokens),      // card, cardPadded
    tabs: createTabsPresets(tokens),
    input: createInputPresets(tokens),
    ...createTablePresets(tokens),     // table, tableCompact, tableMini
    form: createFormPresets(tokens),
    external: createExternalPresets(tokens),
});
